import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CompareCrmPricesWrapper from "@components/layouts/compareCrmPricesWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function InsureYourCarHome(): ReactElement {
    return (
        <CompareCrmPricesWrapper>
            <TermsAndConditions category="CRM" domain="CompareCrmPrices.com" />
        </CompareCrmPricesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
